<style>
.ivu-radio-group{
  display: block;
  margin-bottom: 10px;
}
</style>
<template>
	<Layout>
		<Content :style="{'padding': '10px'}">
			<Breadcrumb :style="{margin: '5px 0'}">
				<BreadcrumbItem>通用管理 > <b>优惠券列表</b></BreadcrumbItem>
			</Breadcrumb>
			<Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
				<span class="search_span_width">
					<span class="search_span_width_part1">名称：</span>
					<Input v-model="search.name" placeholder="请输入名称" :style="{'width':'110px'}"></Input>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">&nbsp;&nbsp;状态：</span>
					<Select v-model="search.status" clearable style="width:130px">
						<Option value="">请选择</Option>
						<Option value="0">停用</Option>
						<Option value="1">启用</Option>
					</Select>
				</span>
				<span class="search_span_width">
					<span class="search_span_width_part1">&nbsp;&nbsp;渠道：</span>
					<Select v-model="search.channel" clearable style="width:130px">
						<Option v-for="(item,index) in channelList" :value="item.e_name" :key="index">{{ item.title }}</Option>
					</Select>
				</span>
				<Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
			</Card>
			<Card>
				<p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
					<span :style="{'text-align':'center','float':'left'}">
						<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加优惠券</Button>
					</span>
				</p>
				<Card id="tableContent" >
					<Table :columns="tableColumns" row-key="id" update-show-children :data="recordList"></Table>
					<Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getList"/>
				</Card>
			</Card>
		</Content>
		<Modal v-model="showmodal" :footer-hide=true title="优惠券">
			<Form ref="info" :model="info" :label-width="80" :rules="editRule">
				<FormItem label="名称" prop="name">
					<Input v-model="info.name"/>
				</FormItem>
				<FormItem label="类型" prop="type">
					<RadioGroup v-model="info.type">
						<Radio label="1">固定金额</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="前置条件" prop="pre_rule">
					<Input type="textarea" v-model="info.pre_rule" :autosize="{minRows: 2,maxRows: 30}" placeholder='优惠券使用前置条件，配置格式如下
指定商品可用：{"product":[商品ID]}'/>
				</FormItem>
				<FormItem label="使用规则" prop="rule">
					<Input type="textarea" v-model="info.rule" :autosize="{minRows: 2,maxRows: 30}" placeholder='优惠券使用规则，配置格式如下
固定金额：{"userRule":{"fixed":优惠券面额，单位元}}'/>
				</FormItem>
				<FormItem label="过期规则" prop="expire_type">
					<RadioGroup v-model="info.expire_type">
						<Radio label="0">永久有效</Radio>
						<Radio label="1">一天</Radio>
						<Radio label="2">三天</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="开始时间" prop="begin_time">
					<DatePicker type="datetime"  :value="info.begin_time" format="yyyy-MM-dd HH:mm" @on-change="computePeriod($event, 0)" placeholder="有效期" style="width: 300px"></DatePicker>
				</FormItem>
				<FormItem label="结束时间" prop="end_time">
					<DatePicker type="datetime" :value="info.end_time" format="yyyy-MM-dd HH:mm" @on-change="computePeriod($event, 1)" placeholder="有效期" style="width: 300px"></DatePicker>
				</FormItem>
				<FormItem label="是否启用" prop="status">
					<RadioGroup v-model="info.status">
						<Radio label="0">停用</Radio>
						<Radio label="1">启用</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem label="渠道" prop="channel">
					<Select v-model="info.channel" style="width:160px">
						<Option value="">请选择</Option>
						<Option v-for="(item,index) in channelList" :value="item.e_name" :key="index" :disabled="item.e_name=='all'?true:false">{{ item.title }}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="upsert()">提交</Button>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="showsmodal" :footer-hide=true title="发放优惠券">
			<Form ref="sendinfo" :model="sendinfo" :label-width="80" :rules="sendRule">
				<FormItem label="客户手机号" prop="user_ids">
					<Select
						v-model="sendinfo.user_ids"
						multiple
						filterable
						:remote-method="getUserList"
						:loading="loading2">
						<Option v-for="(option, index) in userList" :value="option.id" :key="index">{{option.mobile}}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					<Button type="primary" @click="sendCoupon()">确认</Button>
				</FormItem>
			</Form>
		</Modal>
	</Layout>
</template>
<script>
export default {
	data(){
		return {
			search:{
				name:"",
				status:"",
				channel:"",
			},
			info:{
				id:0,
				name:"",
				type:"1",
				pre_rule:"",
				rule:"",
				expire_type:"",
				begin_time:"",
				end_time:"",
				status:"1",
				channel:""
			},
			sendinfo:{
				coupon_id:0,
				user_ids:[]
			},
			showmodal:false,
			loading2:false,
			userList:[],
			showsmodal:false,
			channelList:[],
			recordList:[],
			recordTotal:0,
			page:1,
			editRule :{
				name:[
					{ required: true, message: '名称不能为空', trigger: 'blur' },
					{ max: 11, message: '名称长度不能超过11个字', trigger: 'blur' } 
				],
				type:[
					{ required: true, message: '请选择类型', trigger: 'change' }
				],
				rule:[
					{ required: true, message: '使用规则不能为空', trigger: 'blur' },
				],
				expire_type:[
					{ required: true, message: '请选择过期规则', trigger: 'change' }
				],
				begin_time:[
					{ required: true, message: '请选择开始时间', trigger: 'blur' }
				],
				end_time:[
					{ required: true, message: '请选择结束时间', trigger: 'blur' }
				],
				status:[
					{ required: true, message: '请选择是否启用', trigger: 'change' }
				],
				channel: [
					{ required: true, message: '请选择渠道', trigger: 'blur' }
				],
			},
			sendRule :{
				user_ids:[
					{ required: true, type: 'array', min: 1, message: '请选择客户手机号', trigger: 'blur' }
				]
			},
			tableColumns:[
				{ title: 'ID', key: 'id', align: 'center' },
				{ title: '名称', key: 'name', align: 'center' },
				{ title: '使用规则', key: 'use_rule', align: 'center' },
				{ title: '生效时间', key: 'begin_time', align: 'center'},
				{ title: '失效时间', key: 'end_time', align: 'center'},
				{ title: '状态', key: 'status', align: 'center',
					render:(h,params) =>{
						if (params.row.status == 0) {
							var status = '停用';
						}else {
							var status = '启用';
						}
						return h('span',{},status);
					}
				},
				{ title: '所属渠道', key: 'channel_name', align: 'center'},
				{ title: '操作', key: 'action', align: 'center',
					render: (h, params) => {
						let btns = []
						btns.push(
							h('Button', {
								props: { type: 'warning', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {        
										this.info.id = params.row.id;
										this.info.name = params.row.name;
										this.info.type = params.row.type.toString();
										this.info.pre_rule = params.row.pre_rule;
										this.info.rule = params.row.rule;
										this.info.expire_type = params.row.expire_type.toString();
										this.info.begin_time = params.row.begin_time;
										this.info.end_time = params.row.end_time;
										this.info.status = params.row.status.toString();
										this.info.channel = params.row.channel;
										this.showmodal = true;
									}
								}
							}, '编辑'),
						);
						btns.push(
							h('Button', {
								props: { type: 'error', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.del(params.row.id);
									}
								}
							}, '删除'),
						);
						if (params.row.status == 1) {
							btns.push(
								h('Button', {
									props: { type: 'success', size: 'small' },
									style: { marginRight: '5px', marginBottom: '5px'},
									on: {
										click: () => {
											this.sendinfo.coupon_id = params.row.id;
											this.sendinfo.user_ids = [];
											this.showsmodal = true;
										}
									}
								}, '发放'),
							);
						}
						btns.push(
							h('Button', {
								props: { type: 'success', size: 'small' },
								style: { marginRight: '5px', marginBottom: '5px'},
								on: {
									click: () => {
										this.$router.push({ path: `/common/userCouponList?coupon_id=`+params.row.id });
									}
								}
							}, '领取记录'),
						);
						return h("div", btns);
					}
				}
			],
		}
	},
	mounted:function(){
		this.getChannelList();
		this.getList();
	},
	computed:{},
	methods:{
		addModal(){
			this.info = {
				id:0,
				name:"",
				type:"1",
				pre_rule:"",
				rule:"",
				expire_type:"",
				begin_time:"",
				end_time:"",
				status:"1",
				channel:""
			};
			this.showmodal = true;
		},
		closeModal(){
			this.showmodal = false;
			this.showsmodal = false;
		},
		getChannelList(){
			this.http1.get('/coupon/channelList').then(response=>{
				let data = response.data;
				if (data.code !== 0) {
					alert(data.message);
				} else {
					if (data.data) {
						this.channelList = data.data;
					}
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getList(page = this.page){
			this.page = page;
			let p = {'page':page};
			let params = Object.assign(this.search, p);
			this.http1.get('/coupon/list', {params:params}).then(response=>{
				let data = response.data;
				if (data.code !== 0){
					alert(data.message);
				} else {
					this.recordList = data.data.list;
					this.recordTotal = data.data.total;
				}
			}).catch(()=>{
				this.$Message.error('网络错误');
			});
		},
		getUserList(query){
			if (query !== '') {
				this.loading2 = true;
				setTimeout(() => {
					this.loading2 = false;
					this.http.get('/admin/user/userList', {params:{mobile:query}}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							alert(data.message);
						} else {
							this.userList = data.data.list;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}, 200);
			}
		},
		computePeriod(e, type){
			if (type == 0) {
				this.info.begin_time = e;
			} else {
				this.info.end_time = e;
			}
		},
		upsert(){
			this.$refs["info"].validate((valid) => {
				if(valid){
					this.http1.post('/coupon/upsert', this.info).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							alert(data.message);
						} else {
							this.getList(this.page);
							this.showmodal = false;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}
			});
		},
		del(id){
			this.$Modal.confirm({
				content: '<p>请确认是否删除该优惠券？</p>',
				onOk: () => {
					this.showAllmodal = false;
					this.http1.post('/coupon/del', {id:id}).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('删除成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				},
			});
		},
		sendCoupon(){
			this.$refs["sendinfo"].validate((valid) => {
				if(valid){
					this.showsmodal = false;
					this.http1.post('/coupon/sendCoupon', this.sendinfo).then(response=>{
						let data = response.data;
						if (data.code !== 0) {
							this.$Message.error(data.message);
							return false;
						} else {
							this.$Message.info('发放成功');
							this.getList(this.page);
							return true;
						}
					}).catch(()=>{
						this.$Message.error('网络错误');
					});
				}
			});
		},
	}
}
</script>
